<template>
  <div class="resultItem col-md-6 col-lg-4">
    <a :href="resultItem.url">
      <div class="bild">
        <div class="overlay"></div>
        <Image
          :imageUrl="resultItem.huvudbild"
          :smallWidth="515"
          :mediumWidth="515"
          :largeWidth="515"
          :altText="''"
        >
        </Image>
      </div>
      <span class="rubrik">{{ resultItem.rubrik }}</span>
    </a>
    <div class="projektetikett">
      <span class="projekttext">{{ resultItem.projekttyp }}</span>
      <span class="artext">{{ resultItem.ar }}</span>
    </div>
    <div>{{ programArskurs }}</div>
    <div>{{ resultItem.student }}</div>
    <div>{{ resultItem.anpassatAlternativ }}</div>
  </div>
</template>

<script>
import Image from "common/js/vue/image/image.vue";

export default {
  name: "GalleriResultItem",
  props: {
    resultItem: Object,
  },
  components: {
    Image,
  },
  computed: {
    programArskurs() {
      return `${this.resultItem.program}, ${
        _.isEqual(this.$lang, "sv") ? `Årskurs` : `Year`
      } ${this.resultItem.arskursNamn}`;
    },
  },
};
</script>
